import { render, staticRenderFns } from "./ActivateAccount2.vue?vue&type=template&id=53617d33"
import script from "./ActivateAccount2.vue?vue&type=script&lang=ts"
export * from "./ActivateAccount2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports